'use strict';

angular.module('chatEngine.promotion', [
    'chatEngine.services',
    'chatEngine.directives',
    'chatEngine.configuration',
    'chatEngine.submit',
    'chatEngine.dialog',
    'chatEngine.loadingDialog',
    'chatEngine.filters'
])

.controller('PromotionCtrl', ['$scope', '$timeout', '$http', '$location', '$modal', 'imageUploadService',
'Dialog', 'LoadingDialog', 'sessionDataService', 'LISTING_BYLINE_MAX_LENGTH', 'LISTING_DESCRIPTION_MAX_LENGTH',
'URL_REGEX', 'LISTING_FEATURED_BANNER_WIDTH', 'LISTING_FEATURED_BANNER_HEIGHT', 'LISTING_PROFILE_BANNER_WIDTH',
'LISTING_PROFILE_BANNER_HEIGHT',
    function($scope, $timeout, $http, $location, $modal, imageUploadService, Dialog, LoadingDialog,
    sessionDataService, LISTING_BYLINE_MAX_LENGTH, LISTING_DESCRIPTION_MAX_LENGTH, URL_REGEX,
    LISTING_FEATURED_BANNER_WIDTH, LISTING_FEATURED_BANNER_HEIGHT, LISTING_PROFILE_BANNER_WIDTH,
    LISTING_PROFILE_BANNER_HEIGHT) {

    $scope.LISTING_FEATURED_BANNER_WIDTH = LISTING_FEATURED_BANNER_WIDTH;
    $scope.LISTING_FEATURED_BANNER_HEIGHT = LISTING_FEATURED_BANNER_HEIGHT;
    $scope.LISTING_PROFILE_BANNER_WIDTH = LISTING_PROFILE_BANNER_WIDTH;
    $scope.LISTING_PROFILE_BANNER_HEIGHT = LISTING_PROFILE_BANNER_HEIGHT;

    var currentBotId;

    var editedPanels = {};
    var savingPanels = {};
    var panelFieldsMap = {
        'legal': ['tos_url', 'privacy_policy_url'],
        'description': ['byline', 'description']
    };
    var validatorMap = {
        byline: function(s) {
            return (s || '').length <= LISTING_BYLINE_MAX_LENGTH;
        },
        description: function(s) {
            return (s || '').length <= LISTING_DESCRIPTION_MAX_LENGTH;
        },
        tos_url: function(s) {
            return !s || URL_REGEX.test(s);
        },
        privacy_policy_url: function(s) {
            return !s || URL_REGEX.test(s);
        }
    };

    $scope.LISTING_BYLINE_MAX_LENGTH = LISTING_BYLINE_MAX_LENGTH;
    $scope.LISTING_DESCRIPTION_MAX_LENGTH = LISTING_DESCRIPTION_MAX_LENGTH;

    $scope.selectedFeaturedBanner = function(file) {
        setSaving('featured');
        uploadBanner(file, 'featured', function(data) {
            cancelSaving('featured');
            $scope.listing.large_banner_url = $scope.originalListing.large_banner_url = data.large_banner_url;
            $scope.listing.complete = $scope.originalListing.complete = data.complete;
        }, function(data) {
            cancelSaving('featured');

            if(data.message) {
                Dialog.alert('Error', 'An error occurred while updating your featured banner: ' + data.message + '.');
            } else {
                Dialog.alert('Error', 'An error occurred while updating your featured banner.');
            }
        });
    };

    $scope.selectedProfileBanner = function(file) {
        setSaving('profile');
        uploadBanner(file, 'profile', function(data) {
            cancelSaving('profile');
            $scope.listing.small_banner_url = $scope.originalListing.small_banner_url = data.small_banner_url;
            $scope.listing.complete = $scope.originalListing.complete = data.complete;
        }, function(data) {
            cancelSaving('profile');

            if(data.message) {
                Dialog.alert('Error', 'An error occurred while updating your profile banner: ' + data.message + '.');
            } else {
                Dialog.alert('Error', 'An error occurred while updating your profile banner.');
            }
        });
    };

    $scope.deleteFeaturedBanner = function() {
        deleteBanner('featured');
    };

    $scope.deleteProfileBanner = function() {
        deleteBanner('profile');
    };

    $scope.save = function(panel) {
        if(!$scope.isPanelValid(panel)) {
            return;
        }

        var data = {};
        var fields = panelFieldsMap[panel];
        fields.forEach(function(fieldId) {
            data[fieldId] = $scope.listing[fieldId] || null; // backend expects null instead of empty strings
        });

        setSaving(panel);
        $http.patch('/api/v1/listing/' + currentBotId, data).then(function(data) {
            updatePanelValues(panel, data.data);
            editedPanels[panel] = false;
            cancelSaving(panel);
        }, function(data) {
            cancelSaving(panel);
            saveListingError(data);
        });
    };

    $scope.setEditing = function(panel) {
        editedPanels[panel] = true;
    };

    $scope.isEditing = function(panel) {
        return !!editedPanels[panel];
    };

    $scope.cancelEdit = function(panel) {
        editedPanels[panel] = false;

        var fields = panelFieldsMap[panel];
        fields.forEach(function(field) {
            $scope.listing[field] = $scope.originalListing[field];
        });
    };

    $scope.isFieldValid = function(field) {
        var validator = validatorMap[field];
        if(!validator) {
            return true;
        }

        var value = $scope.listing[field];
        return validator(value);
    };

    $scope.isPanelValid = function(panel) {
        var valid = true;
        var fields = panelFieldsMap[panel];
        fields.forEach(function(field) {
            valid = valid && $scope.isFieldValid(field);
        });
        return valid;
    };

    $scope.isSavingPanel = function(panel) {
        return !!savingPanels[panel];
    };

    $scope.submit = function() {
        if(!$scope.originalListing.complete) {
            Dialog.alert(
                'Missing Fields',
                'You must set a profile picture, a byline and a description before you can submit your bot.'
            );
            return;
        }

        var modal = $modal.open({
            templateUrl: 'views/submission-dialog.html',
            windowClass: 'submission-dialog',
            backdrop: 'static',
            controller: 'SubmitCtrl'
        });

        modal.result.then(function(data) {
            if(data.submit) {
                var loader = LoadingDialog.show('Submitting your bot, please wait...');

                // TODO update API URL
                $http.post('/api/v1/listing/' + currentBotId + '/submit', {
                    'message': data.message
                }).then(function(data) {
                    $scope.listing.submission_status = data.data.submission_status;
                    $scope.originalListing.submission_status = data.data.submission_status;

                    LoadingDialog.hide(loader);
                    Dialog.alert(
                        'Bot Submitted',
                        'Your bot has been submitted for review! ' +
                        'Botsworth will notify you as soon as your bot has been approved!'
                    );
                }, function(data) {
                    LoadingDialog.hide(loader);
                    if(data.data.message) {
                        Dialog.alert('Error',
                            'There was an error when submitting your bot for review: ' + data.data.message + '.');
                    } else {
                        Dialog.alert('Error',
                            'There was an error when submitting your bot for review. Please try again.');
                    }
                });
            }
        });
    };

    $scope.launch = function() {
        Dialog.confirm('Are you sure?', 'Ready to launch your bot in the Bot Shop?').result.then(function() {
            var loader = LoadingDialog.show('Launching your bot, please wait...');

            $http.patch('/api/v1/listing/' + currentBotId, {'live': true}).then(function(data) {
                loadListingSuccess(data);
                LoadingDialog.hide(loader);
                Dialog.alert(
                    'Success!',
                    'Your bot is now live! It may take up to two hours for your bot to appear in the Bot Shop.'
                );
            }, function(data) {
                LoadingDialog.hide(loader);
                if(data.data.message) {
                    Dialog.alert('Error', 'There was an error while launching your bot: ' + data.data.message + '.');
                } else {
                    Dialog.alert('Error', 'There was an error while launching your bot. Please try again.');
                }
            });
        });
    };

    $scope.remove = function() {
        Dialog.confirm(
            'Are you sure?',
            'Remove your bot from the Bot Shop? It may take up to two hours for your bot to be removed.'
        ).result.then(function() {
            var loader = LoadingDialog.show('Removing your bot, please wait...');

            $http.patch('/api/v1/listing/' + currentBotId, {'live': false}).then(function(data) {
                loadListingSuccess(data);
                LoadingDialog.hide(loader);
                Dialog.alert(
                    'Remove Successful',
                    'We\'re sorry to see you go. Please email <a href="mailto:bots@kik.com">bots@kik.com</a> ' +
                    'if there’s anything we can do to help.'
                );
            }, function(data) {
                LoadingDialog.hide(loader);
                if(data.data.message) {
                    Dialog.alert('Error', 'There was an error while removing your bot: ' + data.data.message + '.');
                } else {
                    Dialog.alert('Error', 'There was an error while removing your bot. Please try again.');
                }
            });
        });
    };

    function setSaving(panel) {
        savingPanels[panel] = true;
    }

    function cancelSaving(panel) {
        savingPanels[panel] = false;
    }

    function uploadBanner(file, type, success, error) {
        var options;
        if(type === 'featured') {
            options = {
                'width': LISTING_FEATURED_BANNER_WIDTH,
                'height': LISTING_FEATURED_BANNER_HEIGHT
            };
        } else {
            options = {
                'width': LISTING_PROFILE_BANNER_WIDTH,
                'height': LISTING_PROFILE_BANNER_HEIGHT
            };
        }
        imageUploadService.upload(file, '/api/v1/listing/' + currentBotId + '/' + type + '_banner', options)
        .then(success, error);
    }

    function init() {
        $scope.loading = true;

        // Avoids errors in the console
        $scope.listing = {};
        $scope.originalListing = {};

        currentBotId = sessionDataService.getCurrentBotId() || null;
        if(currentBotId) {
            loadListing();
        } else {
            $scope.$on('sessionDataUpdated', init);
        }
    }

    function loadListing() {
        $http.get('/api/v1/listing/' + currentBotId).then(loadListingSuccess, loadListingError);
    }

    function loadListingSuccess(data) {
        $scope.loading = false;
        $scope.listing = data.data;

        // Defaulting null values to empty strings for the view
        $scope.listing.description = $scope.listing.description || '';
        $scope.listing.byline = $scope.listing.byline || '';
        $scope.listing.tos_url = $scope.listing.tos_url || '';
        $scope.listing.privacy_policy_url = $scope.listing.privacy_policy_url || '';

        $scope.originalListing = angular.copy($scope.listing);
    }

    function loadListingError() {
        Dialog.alert('Error', 'Error loading your promotion settings. Please try again later.').result.then(function() {
            $location.path('/reporting');
        }, function() {
            $location.path('/reporting');
        });
    }

    function saveListingError(data) {
        $scope.loading = false;
        if(data.data.message) {
            Dialog.alert('Error', 'Error saving your promotion settings: ' + data.data.message + '.');
        } else {
            Dialog.alert('Error', 'Error saving your promotion settings. Please try again later.');
        }
    }

    function updatePanelValues(panel, data) {
        var fields = panelFieldsMap[panel];
        fields.forEach(function(field) {
            $scope.listing[field] = $scope.originalListing[field] = data[field] || '';
        });
        $scope.listing.complete = $scope.originalListing.complete = data.complete; // always needs update
    }

    function deleteBanner(type) {
        Dialog.confirm('Are you sure?', 'Remove your ' + type + ' banner?').result.then(function() {
            setSaving(type);

            $http.delete('/api/v1/listing/' + currentBotId + '/' + type + '_banner').then(function(data) {
                cancelSaving(type);
                loadListingSuccess(data);
            }, function(data) {
                cancelSaving(type);
                if(data.data.message) {
                    Dialog.alert(
                        'Error',
                        'Error while removing your ' + type + ' banner: ' + data.data.message + '. Please try again.'
                    );
                } else {
                    Dialog.alert(
                        'Error',
                        'There was an error while removing your ' + type + ' banner. Please try again.'
                    );
                }
            });
        });
    }

    init();
}]);
